module.exports = __webpack_public_path__ + "img/plant-right-top.3c84b483.svg";